<template>
  <div class="content__header">
    <div class="home__header-flex content">
      <div class="relative w-100">
        <div class="home__title">{{ content.title }}</div>
        <button
          v-if="mq.mdPlus"
          class="button button__video home__header-video"
          :class="{ '-bottom': $i18n.locale === 'en' }"
          @click="$store.dispatch('openModalVideo', content.video)"
        >
          <span class="home__header-icon">
            <Icon id="play" />
          </span>
          <span>{{ content.video_button }}</span>
        </button>
        <div v-else class="button__circle home__header-video -mobile">
          <button class="button__front" @click="$store.dispatch('openModalVideo', content.video)">
            <Icon id="play" />
          </button>
        </div>
      </div>
      <div class="home__header-side">
        <div class="home__header-legend">
          {{ content.description }}
        </div>
        <div class="home__header-button">
          <DynamicLink :button="content.button" :link="link" :page="page" />
        </div>
        <div class="text__accent home__header-quote">
          {{ content.tagline }}
        </div>
      </div>
    </div>
    <div class="home__header-relative" :class="{ content: mq.mdPlus }">
      <div class="home__header-relative">
        <Image :source="content.image" class="home__header-img" />
        <button @click.stop="$store.dispatch('openFamilyOffice')" class="home__header-family">
          <span class="home__header-family-icon">
            <Icon id="dvfo" />
          </span>
          <span>
            <span style="display: block">{{ $t('family.header.title') }}</span>
            <span style="display: block">{{ $t('family.header.subtitle') }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import DynamicLink from '@/components/small/DynamicLink.vue'

export default {
  name: 'HomeHeader',
  inject: ['mq'],
  components: { DynamicLink, Icon, Image },
  props: {
    content: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
  },
}
</script>
